export enum GameState {
  Ready,
  Playing,
  Paused,
  GameOver,
}

export enum Key {
  Up = 38,
  Down = 40,
  Left = 37,
  Right = 39,
  Space = 32,
  P = 80,

  W = 87,
  S = 83,
  A = 65,
  D = 68,
}

export enum Direction {
  Left = 0,
  Right = 1,
  Up = 2,
  Down = 3,
}
